import React from 'react';
import classNames from 'classnames/bind';
import { Button, Switch } from '@beef/ui-kit';
import { Description } from "./components/Description";
import { BundleImage } from "./components/BundleImage";
import style from "./styles.pcss";
export { BundleImage };
var cn = classNames.bind(style);
export var BundleSwitcher = function BundleSwitcher(_ref) {
  var onSwitch = _ref.onSwitch,
    isActive = _ref.isActive,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('component')
  }, /*#__PURE__*/React.createElement(Description, {
    title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u044B\u0433\u043E\u0434\u043D\u044B\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClick,
    textColor: "contentAccent1",
    variant: "plain"
  }, "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C, \u0447\u0442\u043E \u0432 \u043D\u0451\u043C")), /*#__PURE__*/React.createElement(Switch, {
    checked: isActive,
    name: "bundle-switch",
    onChange: onSwitch
  }));
};